import {
  CREATE,
  DELETE,
  fetchUtils,
  GET_LIST,
  GET_MANY,
  GET_MANY_REFERENCE,
  GET_ONE,
  UPDATE,
  UPDATE_MANY,
} from 'react-admin';
import crudProvider from 'ra-data-nestjsx-crud';
import loopbackClient from '../lib/react-admin-loopback';

const fetchJson = (url, options = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: 'application/json' });
  }
  // add your own headers here
  options.headers.set('Access-Control-Expose-Headers', 'Content-Range');
  return fetchUtils.fetchJson(url, options);
};

const mappingType = {
  [GET_LIST]: 'getList',
  [GET_ONE]: 'getOne',
  [GET_MANY]: 'getMany',
  [GET_MANY_REFERENCE]: 'getManyReference',
  [CREATE]: 'create',
  [UPDATE]: 'update',
  [UPDATE_MANY]: 'updateMany',
  [DELETE]: 'delete',
};
const dataProviders = [
  {
    serverType: 'loopback',
    resources: [],
  },
  {
    serverType: 'nestjs',
    resources: ['order', 'order-items'],
  },
];

export const multiDataProvider = (type, resource = '', params) => {
  console.log(type, resource, params);
  const dataProviderMapping = dataProviders.find((dp) => {
    const rootResource = resource.split('/')[0];
    return dp.resources.includes(rootResource);
  });

  switch (dataProviderMapping?.serverType) {
    case 'nestjs':
      return crudProvider(process.env.REACT_APP_FCS_API_URL)[mappingType[type]](
        resource,
        params
      );
    default:
      return loopbackClient(process.env.REACT_APP_API_URL)(
        type,
        resource,
        params
      );
  }
};

export default multiDataProvider;
